var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 6.66645H14.1668V5.17478C14.1668 2.99978 12.5752 1.05811 10.4085 0.849781C7.92516 0.616447 5.8335 2.56645 5.8335 4.99978V6.66645H3.3335V18.3331H16.6668V6.66645ZM10.0002 14.1664C9.0835 14.1664 8.3335 13.4164 8.3335 12.4998C8.3335 11.5831 9.0835 10.8331 10.0002 10.8331C10.9168 10.8331 11.6668 11.5831 11.6668 12.4998C11.6668 13.4164 10.9168 14.1664 10.0002 14.1664ZM7.50016 6.66645V4.99978C7.50016 3.61645 8.61683 2.49978 10.0002 2.49978C11.3835 2.49978 12.5002 3.61645 12.5002 4.99978V6.66645H7.50016Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscnIcon);
export default __webpack_public_path__ + "static/media/discn-icon.e398746b2307dfc76979a7a892726d99.svg";
export { ForwardRef as ReactComponent };